import { render, staticRenderFns } from "./T1HeaderContact.vue?vue&type=template&id=ac0073d4&scoped=true&"
import script from "./T1HeaderContact.vue?vue&type=script&lang=js&"
export * from "./T1HeaderContact.vue?vue&type=script&lang=js&"
import style0 from "./T1HeaderContact.vue?vue&type=style&index=0&id=ac0073d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac0073d4",
  null
  
)

export default component.exports